import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";
import {VwpLicense} from "../../../../store/generated/api.ts";
import {Progress} from "../../../basic/progress";
import {cn} from "../../../../utils/utils";

interface LicenseQuotasProps {
    license: VwpLicense;
    minPercentageUsed?: number;
    className?: string;
}

export function LicenseQuotas({license, minPercentageUsed = 0, className}: LicenseQuotasProps) {
    const {t} = useTranslationWithKeys();

    const quotas = (license.quotas ?? []).filter(quota => (quota.percentageUsed ?? 0) >= minPercentageUsed);

    if (quotas.length === 0) {
        return null;
    }

    const formatDate = (dateString?: string) => {
        if (!dateString) return null;
        return new Date(dateString).toLocaleDateString();
    };

    return (
        <div className={cn("p-4 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4", className)}>
            {quotas.map((quota, index) => (
                <div key={index} className="space-y-2">
                    <div className="flex items-center justify-between">
                        <span className="text-sm font-medium">
                            {quota.entitlement ? t(`licenses.quotas.${quota.entitlement}`, quota.entitlement) : t('licenses.quotas.unknownEntitlement')}
                        </span>
                        <span className="text-sm text-muted-foreground">
                            {quota.currentUsage ?? 0} / {quota.limit ?? 0}
                        </span>
                    </div>
                    <Progress
                        value={Math.min(100, quota.percentageUsed ?? 0)}
                        className="h-2"
                        indicatorClassName={(quota.percentageUsed ?? 0) >= 100 ? "bg-[#D64545]" : "bg-green-500"}
                    />
                    {(quota.periodStart || quota.periodEnd) && (
                        <div className="text-xs text-muted-foreground">
                            {quota.periodStart && formatDate(quota.periodStart)}
                            {quota.periodStart && quota.periodEnd && ' - '}
                            {quota.periodEnd && formatDate(quota.periodEnd)}
                        </div>
                    )}
                </div>

            ))}
        </div>
    );
}